import * as $ from 'jquery';
import { disposableSubscription, Lazy } from 'common/barrels/core';

import { Control } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';
import { click } from 'common/rxui/core';

import 'runtime/styles/controls/checkbox.less';

var togglesOnTransitionFromIndeterminate = new Lazy(() => {
    var $test = $('<input type="checkbox" checked="false" />').prop('indeterminate', true).appendTo($('body'));
    $test.click();
    var value = $test.prop('checked');
    $test.remove();
    return !value;
});

export class CheckBox extends Control {
    private $checkbox: JQuery;

    constructor(args: ControlArgs) {            
        super(args);

        this.methods.register(this.config.elementName, this);

        this.$element.addClass('control-container checkbox noselect');

        var $sizingContainer = $('<div />').appendTo(this.$element);

        this.$checkbox = $('<input type="checkbox"/>').appendTo($sizingContainer).addClass(this.config.alignright === true ? 'checkbox-right' : 'checkbox-left');

        this.applyTooltip(this.$checkbox);

        this.pushValueToCheckbox(this.config['content.IsChecked']);

        this.subscriptions = disposableSubscription(
            click(this.$checkbox).map(() => this.pullValueFromCheckbox()).subscribe(x => {
                this.$element.triggerHandler('content.IsChecked', [x]);

                if (x === true)
                    this.triggerEvent('Checked');

                if (x === false)
                    this.triggerEvent('Unchecked');

                this.triggerEvent('Value Changed');
            }),
            this.processBindings(this.config),
            this.managePrimaryBinding('content.IsChecked')
        );

        this.initialize();
    }

    private pullValueFromCheckbox(): boolean {
        return this.$checkbox.prop('indeterminate') ? null : this.$checkbox.prop('checked');
    }

    private pushValueToCheckbox(v: boolean) {
        this.$checkbox.prop('checked', v !== null ? v : !togglesOnTransitionFromIndeterminate.value());
        this.$checkbox.prop('indeterminate', v !== true && v !== false);
    }

    'content.IsChecked'(newValue: boolean) {
        this.checkInitialValueReceived();

        this.pushValueToCheckbox(newValue);
    }

    focus() { this.$checkbox.focus(); }

    applyEnabledState(value: boolean) {
        (<HTMLInputElement>this.$checkbox[0]).disabled = !value;
    }

    tabIndexElements() {
        return this.$checkbox;
    }
}

registerBinding('checkbox', CheckBox);